
    var riot = require('riot')
    //src: starling/src/tags/collaborator-activity-banner.html
riot.tag2('collaborator-activity-banner',
  '<div> <span ref="name">{this.getUserDisplayName()}</span> made changes. <span ref="refresh" class="refresh-collab-edit" 2>refresh</span> or <span ref="continue" class="continue-collab-edit" 3>continue editing</span> </div>',
  'collaborator-activity-banner { position: relative; float: left; background: white; white-space: nowrap; top: 2px; z-index: 1; font-size: 12px; border-radius: 3px; padding: 4px; pointer-events: all; cursor: default; } collaborator-activity-banner > div > span { font-weight: 500; filter: brightness(0.9); cursor: pointer; }',
  'riot-style="{this.getStyle()}"', function(opts) {
'use strict';

var _this = this;

var _searchUi = require('lib/search-ui');

var _collaboratorsUi = require('lib/collaborators-ui');

var _util = require('lib/util');

this.canvas = opts.canvas;
this.canvas.collaboratorActivityBanner = this;
this.nodeId = opts.nodeId;
this.regionId = opts.regionId;
this.field = opts.field;
this.user = opts.user;

this.getStyle = function () {
  if (!_this.user) return '';
  var color = (0, _util.colorFromUserId)(_this.user.id);
  var bgColor = (0, _util.colorFromUserId)(_this.user.id, 0.1);
  return 'color: ' + color + '; background-color: ' + bgColor + ';';
};

this.getUserDisplayName = function () {
  if (_this.user) return _this.user.display_name;
};

this.dismiss = function () {
  _collaboratorsUi.cui.dismissElementChangedBanner();
};

this.on('mount', function () {

  _this.refs.refresh.addEventListener('click', function (e) {
    e.stopPropagation();
    e.preventDefault();

    var nodeId = _this.nodeId,
        regionId = _this.regionId,
        field = _this.field;

    if (nodeId) {
      var nodeTag = _this.canvas.nodeTags[nodeId];
      if (nodeTag) {
        _this.dismiss();
        var node = _this.canvas.store.getNode(nodeId);
        if (field === 'title') {
          nodeTag.updateTitleDisplay(node.title);
        } else if (field === 'summary') {
          nodeTag.updateSummaryDisplay(node.summary);
        }
        nodeTag.updateTopLevelNeighborsLite();
        nodeTag.refs.sitePreviewer && nodeTag.refs.sitePreviewer.update();
        _searchUi.searchUI.refreshResults();
      }
      _this.canvas.defocusInput();
    } else if (regionId) {
      var regionTag = _this.canvas.regionTags[regionId];
      if (regionTag) {
        regionTag.refreshTitle();
      }
      _this.canvas.defocusInput();
    }
  });

  _this.refs.continue.addEventListener('click', function (e) {
    e.stopPropagation();
    e.preventDefault();

    var nodeId = _this.nodeId,
        regionId = _this.regionId,
        field = _this.field;

    if (nodeId) {
      var nodeTag = _this.canvas.nodeTags[nodeId];
      if (nodeTag) {
        _this.dismiss();
      }
    } else if (regionId) {
      var regionTag = _this.canvas.regionTags[regionId];
      if (regionTag) {
        _this.dismiss();
      }
    }
  });
});
});
    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('collaborator-activity-banner')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/collaborator-activity-banner.html
// module id = 776
// module chunks = 0